import { MaterialIcons } from "@expo/vector-icons";
import { Box, Button, Center, HStack, Icon, Pressable, Text, VStack } from "native-base";
import React from "react";

import HomeBackground from "@/assets/svgs/HomeBackgroud";
import SearchInput from "@/components/atoms/SearchInput";
import AppStatusBar from "@/components/atoms/StatusBar";
import SacButton from "@/components/molecules/SacButton";
import Container from "@/components/organisms/Container";
import PromotionList from "@/components/organisms/PromotionList";
import StoreList from "@/components/organisms/StoreList";
import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { RootNavigation } from "@/navigation/Root";
import { HomeNavigation } from "@/navigation/stacks/HomeStack";

import { StoresByTypeScreenProps } from "./types";

const StoresByTypeMobile = ({
  storeType,
  promotionList,
  isLoadingPromotionList,
  storeList,
  isLoadingStoreList,
  onLoadMoreStores,
  onSelectStore,
}: StoresByTypeScreenProps) => {
  const homeNavigation = useAppNavigation<HomeNavigation>();
  const rootNavigation = useAppNavigation<RootNavigation>();
  const { width, height } = useViewport();
  const bgHeight = height / 1.5;

  return (
    <Container px="0" pt="0" pb="16">
      <AppStatusBar isSecondaryBg />
      <VStack w="100%" pb="12" bgColor="transparent">
        <Box position="absolute" top="0" left="0" zIndex={-1} bgColor="secondary.400">
          <HomeBackground width={width} height={bgHeight} />
        </Box>
        <VStack w="100%" padding="2" zIndex={1} bgColor="transparent">
          <HStack justifyContent="space-between" alignItems="center">
            <Button variant="ghost" onPress={() => homeNavigation.goBack()}>
              <Icon as={<MaterialIcons name="arrow-back-ios" />} size="xl" color="primary.600" />
            </Button>
            <Text fontSize="xl" bold isTruncated flexGrow={1}>
              {storeType?.nome}
            </Text>
            <Box>
              <SacButton floatMode={false} />
            </Box>
          </HStack>
          <Center mt="8">
            <Pressable w="80%" onPress={() => rootNavigation.navigateBetweenStacks("search")}>
              <SearchInput h="48px" fontSize="md" editable={false} />
            </Pressable>
          </Center>
        </VStack>
        <PromotionList data={promotionList} isLoading={isLoadingPromotionList} />
        <Center>
          <Text fontSize="2xl" color="text.600" bold my="4" p="2">
            {storeType?.nome}
          </Text>
        </Center>
        <StoreList
          data={storeList}
          isLoading={isLoadingStoreList}
          onLoadMore={onLoadMoreStores}
          onSelect={onSelectStore}
        />
      </VStack>
    </Container>
  );
};

export default StoresByTypeMobile;
